import { useEffect, useMemo, useState } from "react";

type UseTableSearchOptions = {
  debounceMs?: number;
  initialValue?: string;
};

type UseTableSearchResult = {
  searchValue: string;
  debouncedSearchValue: string;
  setSearchValue: (value: string) => void;
  clearSearch: () => void;
  hasSearchValue: boolean;
};

export const useTableSearch = (options?: UseTableSearchOptions): UseTableSearchResult => {
  const [searchValue, setSearchValue] = useState(options?.initialValue ?? "");
  const [debouncedSearchValue, setDebouncedSearchValue] = useState(options?.initialValue ?? "");

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, options?.debounceMs ?? 200);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [searchValue, options?.debounceMs]);

  const hasSearchValue = useMemo(() => searchValue.trim().length > 0, [searchValue]);

  return {
    searchValue,
    debouncedSearchValue,
    setSearchValue,
    clearSearch: () => setSearchValue(""),
    hasSearchValue
  };
};
